import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '@app/services/auth/auth.service';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import { ToastService } from '@app/services/toast.service';
import { TourGuideService } from '@app/services/tour-guide.service';
import { WfQueueManagerService } from '@app/services/wf-queue-manager.service';
import { Messages } from '@app/util/messages.util';
import { Messages as msg } from '@app/src/util/messages';
import { ConfirmDialogComponent, ConfirmDialogModel, WfRunDialogModel } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TourGuideContent } from '@app/src/util/tour-guide-content.util';
import { WorkflowRunService } from '@app/services/workflow-run.service';

@Component({
    selector: 'app-mat-card',
    templateUrl: './mat-card.component.html',
    styleUrls: ['./mat-card.component.scss']
})
export class MatCardComponent implements OnInit {

    /****************** Variable declaration ******************/
    perfDtl: { [key: string]: any } = {
        factors: ['success', 'failed', 'inprogress', 'aborted', 'dispatched', 'github_abort', 'user_abort', 'requested', 'queued', 'cancelled'],
        success: { icon: 'check_circle_outline', color: '#36d712' },
        failed: { icon: 'highlight_off', color: '#d6001e' },
        inprogress: { icon: 'pending', color: '#0088ff' },
        aborted: { icon: 'error_outline', color: '#ef911a' },
        github_abort: { icon: 'error_outline', color: '#ef911a' },
        user_abort: { icon: 'error_outline', color: '#ef911a' },
        dispatched: { icon: 'incomplete_circle', color: '#7cddec' },
        requested: { icon: 'donut_large', color: '#7cddec' },
        queued: { icon: 'autorenew', color: '#ef911a' },
        cancelled: { icon: 'cancel', color: '#ef911a' }
    }
    wfDetails: any;
    getNoData = msg.no_records; //for getting no data available message
    tourId = TourGuideContent;
    activeCard: any;

    wktkt = Messages.wfRun.worktkt;
    gitAction = Messages.wfRun.openGitAction;
    rerun = Messages.wfRun.reRunWf;
    moreDet = Messages.moreDetails;

    /****************** Input and Output decorators ******************/
    @Input() data: any[];
    @Input() page: string;
    @Input() wfType: any;
    @Output() cardClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() searchClear: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Constructor
     */
    constructor(
        public cf: CommonFunctionalitiesService,
        public tourGuideService: TourGuideService,
        private ts: ToastService,
        public authService: AuthService,
        private wfQueueService: WfQueueManagerService,
        public dialog: MatDialog,
        public wfRunService: WorkflowRunService
    ) { }

    /** ngOnInit */
    ngOnInit() {
        this.defaultActiveCard();
    }

    /** ngOnChanges */
    ngOnChanges() {
        /** 
         * when new set of data is loaded activeCard stores the data from the serivce 
         * comparing it with the actutal data
         */
        this.activeCard = this.data.find(object => object === this.wfRunService.activeCard);

        if (this.searchClear) {
            this.wfRunService.activeCard = null;
        }
    }

    /**set the first card active */
    defaultActiveCard() {
        this.onCardClick(this.data[0]);
    }

    /** On card clicked */
    onCardClick(data: any) {
        this.wfRunService.activeCard = data;
        this.cardClicked.emit(data);
    }

    /** wf run rerun */
    wfRunRerun(data: any) {
        if (this.tourGuideService.isStartTour) {
            this.ts.showSuccess(Messages.success, Messages.manualWfTrigger.reRunSuccess);
        } else {
            //Check for access
            if (!this.authService.permissions['rerun-workflow'] || this.cf.statusArr.includes(data?.status.toLowerCase())) return;

            this.wfQueueService.reRunExisitingWf(data.jobId).subscribe((resp: any) => {
                this.ts.showSuccess(Messages.success, Messages.manualWfTrigger.reRunSuccess);
            }, (error: any) => {
                this.ts.showError(Messages.error, Messages.manualWfTrigger.reRunFail);
            })
        }
    }

    /**moreDetails of workflow-run  */
    moreDetails(data: any) {
        let dataSource = [data];
        const dialogData = new WfRunDialogModel('wfRun', dataSource, this.wfType);
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }
}
